<template>
  <div class="mb-3">
    <div class="row">
      <div class="col-md-12">
        <div class="row">
          <h5 class="mb-3">Cnae</h5>
        </div>
      </div>
    </div>
    <Loader :loading="httpSend">
      <div class="row">
        <div class="col-md-12">
          <b-form-group label="Cnae - Código Nacional de Atividade Econômica" label-for="cnae_id_codigo">
            <multiselect
                id="cnae_id_codigo"
                v-model="cnae_select"
                placeholder="Selecione o Cnae"
                :custom-label="labelCnae"
                track-by="cnae_codigo"
                :options="cnaes"
                :close-on-select="true"
                :option-height="104"
                :searchable="true"
                :loading="isLoading"
                :reset-after="true"
                :internal-search="false"
                :clear-on-select="false"
                :max-height="600"
                :show-no-results="false"
                :hide-selected="true"
                :allowEmpty="false"
                @search-change="pesquisarCnae"
                @select="addCnae"
                @remove="removerAtividadeSelect"
                :show-labels="false">
              <template slot="option" slot-scope="props">
                <div class="option__desc">
                  <span class="option__title">{{ props.option.cnae_codigo }} - {{ props.option.cnae_nome }}</span>
                </div>
              </template>
              <span slot="noOptions">Digite para pesquisar</span>
            </multiselect>
            <h6 v-show="list_cnae && list_cnae.length < 1" class="text-danger">Necessário selecionar pelo menos uma
              cnae</h6>
            <h6 v-show="temServicos && tps_tipo === 4" class="text-danger">Não prestadores devem selecionar CNAE sem
              atividades vinculadas.</h6>
          </b-form-group>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="table-responsive">
            <table class="table mb-0">
              <thead>
              <tr>
                <th>Principal</th>
                <th>Código</th>
                <th>Descrição</th>
                <th>Dt. Inclusão</th>
                <th>Remover</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(c, index) in list_cnae" v-bind:key="c.cnae_codigo">
                <td class="text-center">
                  <b-form-checkbox
                      :key="index"
                      v-model="c.tpc_principal"
                      @change="defineCnaePrincipal(c)"
                      :value="true"
                      :unchecked-value="false"
                      class="custom-checkbox custom-checkbox-outline custom-checkbox-primary mb-3">
                  </b-form-checkbox>
                <td>{{ c.cnae_codigo }}</td>
                <td>{{ c.cnae_nome }}</td>
                <td><input v-model="c.tpc_inclusao"
                           type="date" class="form-control"/></td>
                <td class="text-center">
                  <button type="button" @click="removerCnae(c)" class="btn btn-outline-danger btn-sm"><i
                      class="bx bxs-trash"></i></button>
                </td>
              </tr>
              </tbody>
            </table>
            <h6 v-show="cnaeEscritorioContabilidadeErro" class="text-danger">Informe o CNAE (6920601 - Atividade de
              contabilidade) como Principal</h6>
          </div>
        </div>
      </div>
      <div v-if="tps_tipo !== 4" class="row">
        <div class="col-md-12">
          <div class="row">
            <h5 class="mb-3">Atividades</h5>
          </div>
        </div>
        <div class="col-md-12">
          <b-form-group label="Atividade" label-for="ser_codigo">
            <multiselect
                id="ser_codigo"
                v-model="temp_lista_servico"
                placeholder="Selecione as atividades"
                :custom-label="labelAtividade"
                track-by="ser_codigo"
                :options="servicos"
                :close-on-select="true"
                :option-height="104"
                :searchable="true"
                :loading="isLoading"
                :reset-after="true"
                :internal-search="false"
                :clear-on-select="false"
                :max-height="600"
                :show-no-results="false"
                :hide-selected="true"
                :allowEmpty="false"
                @select="addServico"
                :show-labels="false">
              <template slot="selection" slot-scope="{values}">
                <span class="multiselect__single" v-if="values.length && values.length < 2">{{ values.length }} atividade selecionada</span>
                <span class="multiselect__single" v-if="values.length && values.length > 1">{{ values.length }} atividades selecionadas</span>
              </template>
              <template slot="option" slot-scope="props">
                <div class="option__desc">
                  <span class="option__title">{{ props.option.ser_codigo }} - {{ props.option.ser_descricao }}</span>
                </div>
              </template>
              <span slot="noOptions">Sem atividades</span>
            </multiselect>
            <h6 v-show="list_servicos && list_servicos.length < 1 && servicos && servicos.length > 1"
                class="text-danger">Necessário informar pelo menos uma atividade</h6>
          </b-form-group>
        </div>
        <div class="col-md-12">
          <div class="table-responsive">
            <table class="table mb-0">
              <thead>
              <tr>
                <th>Código</th>
                <th>Descrição</th>
                <th></th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(v, index) in list_servicos" v-bind:key="v.ser_codigo">
                <td>{{ v.ser_codigo }}</td>
                <td>{{ v.ser_descricao }}</td>
                <td class="text-right">
                  <button type="button" @click="removeAtividade(index)" class="btn btn-outline-danger btn-sm"><i
                      class="bx bxs-trash"></i></button>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="row">
            <h5 class="mb-3">Contador</h5>
          </div>
        </div>
      </div>
      <div v-if="contador_pes_cpfcnpj" class="row">
        <div class="col-md-12">
          <p>
            <span v-if="contador_pes_cpfcnpj.length < 11">{{ contador_pes_cpfcnpj | VMask('###.###.###-##') }}</span>
            <span v-else>{{ contador_pes_cpfcnpj | VMask('##.###.###/####-##') }}</span>
            {{ contador_pes_nome }}
          </p>
        </div>
      </div>
      <div v-else class="row">
        <div class="col-md-12">
          <p>Contador não informado</p>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <b-form-checkbox
              v-model="proprio_contador"
              :disabled="!habilida_proprio_contador"
              @change="proprioContador(contador.proprio_contador)"
              :value="true"
              :unchecked-value="false"
              class="custom-checkbox custom-checkbox-outline custom-checkbox-primary mb-3">
            Sou meu próprio contador <span v-show="!habilida_proprio_contador">(Necessário ter atividade 17.19)</span>
          </b-form-checkbox>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="row">
            <h5 class="mb-3">Novo Contador</h5>
          </div>
        </div>
      </div>
      <div v-if="!contador.proprio_contador" class="row">
        <div class="col-md-5">
          <label for="pes_cpfcnpj">CPF/CNPJ do Contador</label>
          <input v-model="pesquisa_contador"
                 v-mask="(pesquisa_contador && pesquisa_contador.length < 15)?'###.###.###-##':'##.###.###/####-##'"
                 v-on:focusout="pesquisaContador(pesquisa_contador)"
                 :class="{'is-invalid': contadorNaoExite}"
                 id="pes_cpfcnpj"
                 type="text"
                 class="form-control"/>
          <div v-show="contadorNaoExite" class="invalid-feedback">
            {{ erroContador }}
          </div>
        </div>
        <div class="col-md-7">
          <label for="contador_nome">Nome/Razão Social</label>
          <input v-model="pesquisa_contador_nome"
                 id="contador_nome"
                 type="text"
                 :disabled="true"
                 class="form-control"/>
        </div>
      </div>
    </Loader>
  </div>
</template>
<script>
import Multiselect from 'vue-multiselect'
import Loader from "@/components/widgets/loader";
import {autocompleteCnae} from "@/api/geral/autocomplete";
import {getContador} from "@/api/core/pessoa";
import {getDate} from "@/helps/util";
import {getCnaeServico} from "@/api/geral/helps";
import store from "@/state/store";

export default {
  components: {
    Loader,
    Multiselect
  },
  props: {
    tps_tipo: {
      type: Number,
    },
    list_cnae: {
      type: Array,
      default: function () {
        return [];
      }
    },
    list_servicos: {
      type: Array,
      default: function () {
        return [];
      }
    },
    up_contador: {
      type: Object,
    },
  },
  data() {
    return {
      temp_lista_cnae: [],
      temp_lista_servico: [],
      temContador: false,
      pesquisa_contador: '',
      pesquisa_contador_nome: '',
      contador: {
        pes_codigo: null,
        pes_nome: null,
        pes_cpfcnpj: null,
        pes_crc: null,
        proprio_contador: false
      },
      contadorNaoExite: false,
      erroContador: "Contador não encontrado",
      cnaeEscritorioContabilidadeErro: false,
      servicos: [],
      cnaes: [],
      cnae_select: null,
      temServicos: false,
      tpc_inclusao: null,
      isLoading: false,
      httpSend: false,
    };
  },
  watch: {
    'servicos': function (newVal) {
      this.temServicos = (newVal && newVal.length > 0);
    },
    'list_cnae': function (newVal) {
      if (newVal && newVal.length > 0) {
        this.cnaeServico();
      }
    },
  },
  computed: {
    habilida_proprio_contador: {
      get: function () {
        const servico = this.list_servicos.filter(s => s.ser_codigo === '17.19');
        return servico.length > 0;
      },
    },
    proprio_contador: {
      get: function () {
        if (this.up_contador.proprio_contador) {
          return this.up_contador.proprio_contador
        }
        return this.contador.proprio_contador;
      },
      set: function (newValue) {
        this.contador.proprio_contador = newValue;
      }
    },
    contador_pes_cpfcnpj: {
      get: function () {
        if (this.up_contador.pes_cpfcnpj) {
          return this.up_contador.pes_cpfcnpj
        }
        return this.contador.pes_cpfcnpj;
      },
      set: function (newValue) {
        this.contador.pes_cpfcnpj = newValue;
      }
    },
    contador_pes_nome: {
      get: function () {
        if (this.up_contador.pes_nome) {
          return this.up_contador.pes_nome
        }
        return this.contador.pes_nome;
      },
      set: function (newValue) {
        this.contador.pes_nome = newValue;
      }
    },
    contador_pes_crc: {
      get: function () {
        if (this.up_contador.pes_crc) {
          return this.up_contador.pes_crc
        }
        return this.contador.pes_crc;
      },
      set: function (newValue) {
        this.contador.pes_crc = newValue;
      }
    },
  },
  methods: {
    setCnaeTemServicos(valor) {
      store.dispatch('solicitacao/cnaeTemServicos', valor);
    },
    pesquisarCnae(search) {
      if (search && search.length > 1) {
        this.isLoading = true;
        autocompleteCnae({query: search}).then(response => {
          if (response.status) {
            this.cnaes = response.dados;
          }
        }).catch(error => {
          console.log(error);
        }).finally(() => {
          this.isLoading = false;
        })
      }
    },
    cnaeServico() {
      this.setCnaeTemServicos(false);
      let array_cnaes = [];
      for (const index in this.list_cnae) {
        array_cnaes.push(this.list_cnae[index].cnae_codigo);
      }
      if (array_cnaes.length > 0) {
        getCnaeServico(array_cnaes).then(response => {
          if (response.status) {
            this.servicos = response.dados;
            if (this.servicos && this.servicos.length > 0) {
              this.setCnaeTemServicos(true);
            }
          }
        }).catch(error => {
          console.log(error);
        });
      } else {
        this.servicos = [];
        this.servicos_ativiades = [];
      }
    },
    labelCnae({cnae_codigo, cnae_nome}) {
      return `${cnae_codigo} - ${cnae_nome}`
    },
    labelAtividade({ser_codigo, ser_descricao}) {
      return `${ser_codigo} - ${ser_descricao}`
    },
    addCnae(selectedOption) {
      if (this.list_cnae.filter(c => c.cnae_codigo.toLocaleLowerCase().indexOf(selectedOption.cnae_codigo.toLocaleLowerCase()) > -1).length > 0) {
        return false;
      }
      let cnae = {
        cnae_codigo: selectedOption.cnae_codigo,
        cnae_nome: selectedOption.cnae_nome,
        tpc_principal: (this.list_cnae && this.list_cnae.length < 1),
        tpc_inclusao: getDate()
      }
      this.list_cnae.push(cnae);
      this.cnaeServico();
      this.verificaEscritorioContabilidade();
    },
    defineCnaePrincipal(cnae) {
      if (cnae.tpc_principal) {
        for (const index in this.list_cnae) {
          if (this.list_cnae[index].cnae_codigo !== cnae.cnae_codigo) {
            this.list_cnae[index].tpc_principal = false;
          }
        }
      }
      let temMarcado = false;
      for (const index in this.list_cnae) {
        if (this.list_cnae[index].tpc_principal) {
          temMarcado = true;
        }
      }
      if (!temMarcado) {
        this.list_cnae[0].tpc_principal = true;
      }
      this.verificaEscritorioContabilidade();
    },
    verificaEscritorioContabilidade() {
      if (this.tps_tipo === 5) {
        this.cnaeEscritorioContabilidadeErro = false;
        let contabilidade = this.list_cnae.findIndex(x => x.cnae_codigo === '6920601' && x.tpc_principal === true)
        if (contabilidade < 0) {
          this.cnaeEscritorioContabilidadeErro = true;
        }
      }
    },
    addServico(selectedOption) {
      let index = this.list_servicos.findIndex(x => x.ser_codigo === selectedOption.ser_codigo)
      if (index < 0) {
        this.list_servicos.push(selectedOption)
      }
    },
    removerCnae(removedOption) {
      let index = this.list_cnae.findIndex(x => x.cnae_codigo === removedOption.cnae_codigo)
      this.list_cnae.splice(index, 1);
      this.cnaeServico();
      this.$emit('resetarListServicos', [])
    },
    removerAtividadeSelect(removedOption) {
      let index = this.list_servicos.findIndex(x => x.ser_codigo === removedOption.ser_codigo)
      if (index) {
        this.list_servicos.splice(index, 1);
      }
    },
    removeAtividade(index) {
      this.list_servicos.splice(index, 1);
      this.temp_lista_servico = this.list_servicos;
    },
    proprioContador(value) {
      if (value) {
        this.contador.pes_codigo = null;
        this.contador.pes_cpfcnpj = null;
        this.contador.pes_nome = null;
        this.contador.pes_crc = null;
        this.contador.proprio_contador = value;
        this.up_contador.pes_codigo = null;
      }
      this.up_contador.proprio_contador = value
    },
    pesquisaContador(pes_cpfcnpj) {
      if (!pes_cpfcnpj) {
        return
      }
      if (pes_cpfcnpj.length < 11) {
        return
      }
      this.httpSend = true;
      getContador({pes_cpfcnpj: pes_cpfcnpj}).then(response => {
        this.contadorNaoExite = false;
        if (response.status) {
          this.contador.pes_codigo = response.dados.pes_codigo;
          this.contador.pes_nome = response.dados.pes_nome;
          this.pesquisa_contador_nome = response.dados.pes_nome;
          this.contador.pes_crc = response.dados.pes_crc;
          this.up_contador.pes_codigo = response.dados.pes_codigo;
        } else {
          this.erroContador = response.mensagem;
          this.contadorNaoExite = true;
        }
      }).catch(error => {
        console.log(error);
      }).finally(() => {
        this.httpSend = false;
      })
    }
  }
};
</script>
<style>

input[type="text"][disabled] {
  background-color: #f6f6f9;
}

.option__title {
  word-wrap: break-word;
  white-space: normal;
}
</style>
